import React from "react";
import SectionShell from "../layout/SectionShell";
import { educationData } from "../../mock/portfolioData";

export function EducationSection() {
  return (
    <SectionShell id="education" title="Education" kicker="Academic">
      <div className="grid gap-4 md:grid-cols-2">
        {educationData.items.map((item) => (
          <article
            key={item.institution}
            className="rounded-2xl border border-slate-800 bg-slate-900/70 p-4 shadow-[0_0_22px_rgba(15,23,42,0.9)]"
          >
            <h3 className="text-sm font-semibold text-slate-50">
              {item.degree}
            </h3>
            <p className="text-xs text-slate-400">{item.institution}</p>
            <p className="mt-1 font-mono text-[11px] font-medium text-cyan-300">
              {item.period}
            </p>
            <ul className="mt-3 list-disc space-y-1.5 pl-4 text-xs text-slate-300">
              {item.details.map((detail) => (
                <li key={detail}>{detail}</li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </SectionShell>
  );
}

export default EducationSection;
